import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Contest } from '../models/contest.model';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ContestService {
  private apiUrl = `${environment.apiUrl}/contests`;

  constructor(private http: HttpClient) {}

  /**
   * Get all contests with optional filters
   */
  getContests(filters?: {
    status?: string;
    search?: string;
    page?: number;
    pageSize?: number;
  }): Observable<PaginatedResponse<Contest>> {
    let params = new HttpParams();

    if (filters?.status) {
      params = params.set('status', filters.status);
    }
    if (filters?.search) {
      params = params.set('search', filters.search);
    }
    if (filters?.page) {
      params = params.set('page', filters.page.toString());
    }
    if (filters?.pageSize) {
      params = params.set('pageSize', filters.pageSize.toString());
    }

    return this.http.get<PaginatedResponse<Contest>>(this.apiUrl, { params });
  }

  /**
   * Get contest by ID
   */
  getContestById(id: number): Observable<ApiResponse<Contest>> {
    return this.http.get<ApiResponse<Contest>>(`${this.apiUrl}/${id}`);
  }

  /**
   * Search contests
   */
  searchContests(query: string): Observable<ApiResponse<Contest[]>> {
    const params = new HttpParams().set('q', query);
    return this.http.get<ApiResponse<Contest[]>>(`${this.apiUrl}/search`, { params });
  }

  /**
   * Get featured contests
   */
  getFeaturedContests(): Observable<ApiResponse<Contest[]>> {
    return this.http.get<ApiResponse<Contest[]>>(`${this.apiUrl}/featured`);
  }

  /**
   * Get public contests (published notices)
   */
  getPublicContests(filters?: {
    nome?: string;
    page?: number;
    size?: number;
  }): Observable<PaginatedResponse<Contest>> {
    let params = new HttpParams();

    if (filters?.nome) {
      params = params.set('nome', filters.nome);
    }
    if (filters?.page !== undefined) {
      params = params.set('page', filters.page.toString());
    }
    if (filters?.size) {
      params = params.set('size', filters.size.toString());
    }

    return this.http.get<PaginatedResponse<Contest>>(`${environment.apiUrl}/public/editais`, { params });
  }

  /**
   * Get public contest by ID (published notice details)
   */
  getPublicContestById(editalId: number): Observable<Contest> {
    return this.http.get<Contest>(`${environment.apiUrl}/public/editais/${editalId}`);
  }
}
